/* eslint-disable no-shadow */
// import Immutable from 'seamless-immutable';
import createReducer from '../../helpers/createReducer';
import {
  quiz as state
} from '../store';

export default createReducer(state, {
  SET_QUIZ: (state, { data }) => ({ ...state, ...data }),
  UPDATE_QUIZ_DATA: (state, { data }) => ({ ...state, ...data }),
  SET_QUIZ_STATE: (state, { data }) => ({ ...state, quizState: data }),
  SET_WHOLE_QUIZ_DATA: (state, { data }) => ({ ...state, ...data })
});
